import { create } from "zustand";
import { persist } from "zustand/middleware";

// The store now only saves and returns the JSON data itself (as any), no id or timestamp

type DraftsData = {
  [dataType: string]: any;
};

interface DraftsStore {
  data: DraftsData;
  saveDraft: (dataType: string, value: any) => void;
  getDraft: (dataType: string) => any;
  clearDraft: (dataType: string) => void;
  clearAllDrafts: () => void;
}

export const useDrafts = create<DraftsStore>()(
  persist(
    (set, get) => ({
      data: {},
      saveDraft: (dataType, value) => {
        set((state) => ({
          data: {
            ...state.data,
            [dataType]: value,
          },
        }));
      },
      getDraft: (dataType) => {
        return get().data[dataType];
      },
      clearDraft: (dataType) => {
        set((state) => {
          const newData = { ...state.data };
          delete newData[dataType];
          return { data: newData };
        });
      },
      clearAllDrafts: () => {
        set(() => ({ data: {} }));
      },
    }),
    {
      name: "drafts-store",
    }
  )
);